<template>
  <div class="workTable">
    <el-row>
      <el-col :span="17">
        <div class="headerinfo">{{word}}</div>
        <OACard header="审批列表">
          <el-button
            @click="select"
            slot="button"
            type="text"
            class="pull-right"
            icon="iconfont icon-shaixuan"
          >筛选</el-button>
          <OAList
            ref="OAList"
            :columns="columns"
            :data="data"
            :loading="loading"
            :param="param"
            @search="handleSearch"
            @rowClick="rowClick"
          ></OAList>
        </OACard>
      </el-col>
      <el-col :span="7">
        <div class="headerinfo"></div>
        <div class="el-dropdown-bg">
          <el-select v-model="userInfo.id">
            <el-option
              v-for="(item,index) in underList"
              :key="index"
              :label="item.value"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <OACalendar
          v-if="calendarShow"
          :workdata="workdata"
          :showLunar="false"
          @showDetail="showDetail"
        ></OACalendar>
        <OATimeline v-if="detailVisible" :timedata="checkInfo"></OATimeline>
      </el-col>
    </el-row>

    <el-dialog title="筛选条件" :visible.sync="dialogVisible" width="30%">
      <form-component :form-data="formData"></form-component>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearValue">重置</el-button>
        <el-button type="primary" @click="getValue">确定</el-button>
      </span>
    </el-dialog>

    <OAModalDetail title="审批详情" :visible="appVisible" :form-data="approvalForm" @on-close="onClose"></OAModalDetail>
  </div>
</template>
<script>
import OACalendar from "@/components/OACalendar/OACalendar";
import OACard from "@/components/OACard/OACard";
import OATimeline from "@/components/OATimeline/OATimeline";
import OAColums from "@/components/OAColums/OAColums";
import OAModalDetail from "@/components/OAModalDetail/OAModalDetail";
import formComponent from "@/components/formComponents/form-component";
import d2Crud from "@d2-projects/d2-crud";
import { word } from "@/common/words";
import { getValue, clearValue, setValue } from "@/common/util";
import workTableApi from "@/services/workTable.js";
import commonApi from "@/services/common.js";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "workTable",
  components: {
    OACalendar,
    OACard,
    OAColums,
    formComponent,
    OATimeline,
    OAModalDetail
  },
  computed: {
    userInfo() {
      if (store.getters.userInfo.id) {
        this.getDate(store.getters.userInfo.id);
      }
      return store.getters.userInfo;
    }
  },
  data() {
    return {
      word: word,
      loading: false,
      workdata: {},
      data: [],
      columns: [
        {
          component: {
            name: OAColums
          }
        }
      ],
      checkInfo: {},
      dialogVisible: false,
      detailVisible: false,
      appVisible: false,
      formData: {
        applyId: {
          formType: "a-auto-search",
          apiType: "getUnder",
          value: undefined,
          placeholder: "请输入姓名或工号",
          label: "姓名/工号："
        },
        applyType: {
          formType: "a-select",
          value: undefined,
          placeholder: "请选择申请类型",
          api: "getApprovalType",
          label: "申请类型："
        },
        status: {
          formType: "a-select",
          value: undefined,
          placeholder: "请选择审批状态",
          api: "getApprovalStatus",
          label: "审批状态："
        },
        applyTime: {
          formType: "a-date-picker",
          type: "daterange",
          value: undefined,
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          label: "起始时间："
        }
      }, //筛选条件
      param: {},
      underList: [], //下属员工列表
      approvalForm: {
        spNum: { label: "审批单号：", formType: "a-span", value: "" },
        approvalName: { label: "审批人：", formType: "a-span", value: "" },
        statusDesc: { label: "审批状态：", formType: "a-span", value: "" },
        applyName: { label: "申请人：", formType: "a-span", value: "" },
        deptName: {
          label: "申请人部门：",
          formType: "a-span",
          value: ""
        },
        applyTime: { label: "申请时间：", formType: "a-span", value: "" }
      },
      calendarShow: false
    };
  },
  created() {},
  mounted() {
    this.getunderlings();
  },
  methods: {
    async getunderlings() {
      let res = await commonApi.getunderlings();
      this.underList = res.data.data;
    },
    async handleSearch(val) {
      this.loading = true;
      let res = await workTableApi.getApprovallist(val);
      this.data = res.data.data;
      this.loading = false;
    },
    getValue() {
      this.param = getValue(this.formData);
      this.dialogVisible = false;
    },
    clearValue() {
      clearValue(this.formData);
      this.param = {};
      this.dialogVisible = false;
    },
    select() {
      this.dialogVisible = true;
    },
    async getDate(id) {
      this.calendarShow = false;
      let res = await workTableApi.getcheckin({ id: id });
      let object = {};
      if (res.data.data.length > 0) {
        res.data.data.map((value, key) => {
          object[value.attendanceDate] = value.status;
        });
      }
      this.workdata = object;
      this.calendarShow = true;
      this.checkInfo = {};
    },
    async showDetail(val) {
      let res = await workTableApi.getcheckininfo({
        date: val.date,
        employeeId: this.userInfo.id
      });
      this.checkInfo = res.data.data;
      this.detailVisible = true;
    },
    rowClick({ row, event, column }) {
      this.appVisible = true;
      this.approvalForm = setValue(row, this.approvalForm);
    },
    onClose() {
      this.appVisible = false;
    }
  }
};
</script>
<style lang="scss">
.workTable {
  .el-col.el-col-17 {
    .headerinfo {
      background: url("../../assets/bg1.png");
      background-size: cover;
      height: 150px;
      margin-bottom: 20px;
      color: #fff;
      line-height: 150px;
      text-align: right;
      border-radius: 4px;
      padding-right: 20px;
    }
  }
  .el-col.el-col-7 {
    padding-left: 20px;
    .headerinfo {
      background: url("../../assets/bg2.png");
      background-size: cover;
      height: 150px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .el-dropdown-bg {
      width: 100%;
      line-height: 40px;
      background: #fff;
      text-align: center;
      border-bottom: 1px dashed #e6e6e6;
      .el-select {
        .el-input__inner {
          width: 150px;
          border: none;
          cursor: pointer;
          text-align: center;
        }
      }
    }
    .OATimeline {
      margin-top: -21px;
    }
    .full-jcalendar__main {
      border: none;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/workTable/workTable.vue